import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Home from './Home.js';
import About from './Pages/about.js';
function App() {
  return (
    <Router>
      <Routes>
        {/* Home route */}
        <Route path="/" element={<Home />} />
        {/* About route */}
        <Route path="/about" element={<About />} />
      </Routes>
    </Router>
  );
}

export default App;
